import { render, staticRenderFns } from "./busOrder2.vue?vue&type=template&id=0ca9e2b3&scoped=true&"
import script from "./busOrder2.vue?vue&type=script&lang=js&"
export * from "./busOrder2.vue?vue&type=script&lang=js&"
import style0 from "./busOrder2.vue?vue&type=style&index=0&id=0ca9e2b3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca9e2b3",
  null
  
)

export default component.exports